import * as Sentry from '@sentry/angular';
import { UserManager } from '../services/user-manager';
import { AppConfig } from './app-config';

export function configRavenLogging() {
    var settings = (window as any).SentrySettings as AppConfig;
    // Configure Sentry.io logging service, this needs to go before NgModule configuration to be able capture errors during the Angular bootstrap process
    if (settings && settings.enableLogging) {
        Sentry.init({
            dsn: settings.sentryIoDsn,
            environment: settings.environment,
            release: UserManager.versionNo,
        });
    }
}



